// extracted by mini-css-extract-plugin
module.exports = {"divTawkIcon":"style_divTawkIcon_2m-Vi","divTawk":"style_divTawk_2SqeF"};